import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import './Section.css';

import { motion } from 'framer-motion';
import { Camera } from 'lucide-react-native';
import { useState } from "react";
import Lightbox from "yet-another-react-lightbox";
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import properties from '../properties.json'
import { StyleSheet } from 'react-native';
import imagen1 from '../assets/MejoresMomentos/1.avif';
import imagen2 from '../assets/MejoresMomentos/2.avif';
import imagen3 from '../assets/MejoresMomentos/3.avif';
import imagen4 from '../assets/MejoresMomentos/4.avif';
import imagen5 from '../assets/MejoresMomentos/5.avif';
import imagen6 from '../assets/MejoresMomentos/6.avif';
import imagen7 from '../assets/MejoresMomentos/7.avif';
import imagen8 from '../assets/MejoresMomentos/8.avif';
import imagen9 from '../assets/MejoresMomentos/9.avif';
import imagen10 from '../assets/MejoresMomentos/10.jpeg';
import imagen11 from '../assets/MejoresMomentos/11.avif';
import imagen12 from '../assets/MejoresMomentos/12.avif';
import imagen13 from '../assets/MejoresMomentos/13.jpg';
import imagen14 from '../assets/MejoresMomentos/14.avif';
import imagen15 from '../assets/MejoresMomentos/15.avif';
import imagen16 from '../assets/MejoresMomentos/16.avif';
import imagen17 from '../assets/MejoresMomentos/17.avif';
import imagen18 from '../assets/MejoresMomentos/18.avif';
import imagen19 from '../assets/MejoresMomentos/19.avif';
import imagen20 from '../assets/MejoresMomentos/20.avif';
import imagen21 from '../assets/MejoresMomentos/21.avif';
import imagen22 from '../assets/MejoresMomentos/22.avif';
import imagen23 from '../assets/MejoresMomentos/23.avif';
import imagen24 from '../assets/MejoresMomentos/24.avif';
import imagen25 from '../assets/MejoresMomentos/25.avif';
import imagen26 from '../assets/MejoresMomentos/26.avif';

export function PhotoGallery() {

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.18 } // Efecto cascada rápido
    },
  };

  const itemVariants = {
    hidden: { scale: 0.8, opacity: 0 },
    visible: { scale: 1, opacity: 1, transition: { duration: 0.4 } },
  };

  const [open, setOpen] = useState(false);
  const [index, setIndex] = useState(0);

  return (
    <div>
      <Lightbox
        index={index}
        open={open}
        close={() => {
          setOpen(false);
        }
        }
        slides={album}
        plugins={[Fullscreen,Thumbnails]}
        on={{
          view: ({ index: currentIndex }) => setIndex(currentIndex),
        }}
      />
      <section id='sectionAlbum' className='sectionBody'>
      <div className='header'>
        <Camera size={32} color={properties.detailsColor} className="icon" />
        <h2 className='title'>Nuestros mejores momentos</h2>
        <div className='line' />
      </div>
      <br />
      <motion.div
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        style={
          styles.card
        }
      >
        {images.map((img) => (
          <motion.div
            key={img.id}
            variants={itemVariants}
            whileHover={{ scale: 1.02 }}
            style={{
              width: '100%',
              // Mantiene el cuadrado perfecto sin importar el ancho
              aspectRatio: '1 / 1',
              backgroundColor: '#eee',
              borderRadius: '4px',
              overflow: 'hidden',
              boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
            }}
          >
            <img
              onClick={() => {
                setIndex(img.index);
                setOpen(true);
              }}
              src={img.src}
              alt={`Foto ${img.id + 1}`}
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                display: 'block'
              }}
            />
          </motion.div>
        ))}
      </motion.div>
      </section>
    </div>
  );
};

const images = [
  {
    src: imagen1,
    title: "Title 1",
    index: 0,
    id: "imagen1"
  },
  {
    src: imagen2,
    title: "Title 2",
    index: 1,
    id: "imagen2"
  },
  {
    src: imagen3,
    title: "Title 3",
    index: 2,
    id: "imagen3"
  },
  {
    src: imagen4,
    title: "Title 4",
    index: 3,
    id: "imagen4"
  },
  {
    src: imagen5,
    title: "Title 5",
    index: 4,
    id: "imagen5"
  },
  {
    src: imagen6,
    title: "Title 6",
    index: 5,
    id: "imagen6"
  },
  {
    src: imagen7,
    title: "Title 7",
    index: 6,
    id: "imagen7"
  },
  {
    src: imagen8,
    title: "Title 8",
    index: 7,
    id: "imagen8"
  },
  {
    src: imagen9,
    title: "Title 9",
    index: 8,
    id: "imagen9"
  }
];

const album = [
  {
    src: imagen1,
    title: "Title 1",
    index: 0,
    id: "imagen1"
  },
  {
    src: imagen2,
    title: "Title 2",
    index: 1,
    id: "imagen2"
  },
  {
    src: imagen3,
    title: "Title 3",
    index: 2,
    id: "imagen3"
  },
  {
    src: imagen4,
    title: "Title 4",
    index: 3,
    id: "imagen4"
  },
  {
    src: imagen5,
    title: "Title 5",
    index: 4,
    id: "imagen5"
  },
  {
    src: imagen6,
    title: "Title 6",
    index: 5,
    id: "imagen6"
  },
  {
    src: imagen7,
    title: "Title 7",
    index: 6,
    id: "imagen7"
  },
  {
    src: imagen8,
    title: "Title 8",
    index: 7,
    id: "imagen8"
  },
  {
    src: imagen9,
    title: "Title 9",
    index: 8,
    id: "imagen9"
  },
  {
    src: imagen10,
    title: "Title 10",
    index: 9,
    id: "imagen10"
  },
  {
    src: imagen11,
    title: "Title 11",
    index: 10,
    id: "imagen11"
  },
  {
    src: imagen12,
    title: "Title 12",
    index: 11,
    id: "imagen12"
  },
  {
    src: imagen13,
    title: "Title 13",
    index: 12,
    id: "imagen13"
  },
  {
    src: imagen14,
    title: "Title 14",
    index: 13,
    id: "imagen14"
  },
  {
    src: imagen15,
    title: "Title 15",
    index: 14,
    id: "imagen15"
  },
  {
    src: imagen16,
    title: "Title 16",
    index: 15,
    id: "imagen16"
  },
  {
    src: imagen17,
    title: "Title 17",
    index: 16,
    id: "imagen17"
  },
  {
    src: imagen18,
    title: "Title 18",
    index: 17,
    id: "imagen18"
  },
  {
    src: imagen19,
    title: "Title 19",
    index: 18,
    id: "imagen19"
  },
  {
    src: imagen20,
    title: "Title 20",
    index: 19,
    id: "imagen20"
  },
  {
    src: imagen21,
    title: "Title 21",
    index: 20,
    id: "imagen21"
  },
  {
    src: imagen22,
    title: "Title 22",
    index: 21,
    id: "imagen22"
  },
  {
    src: imagen23,
    title: "Title 23",
    index: 22,
    id: "imagen23"
  },
  {
    src: imagen24,
    title: "Title 24",
    index: 23,
    id: "imagen24"
  },
  {
    src: imagen25,
    title: "Title 25",
    index: 24,
    id: "imagen25"
  },
  {
    src: imagen26,
    title: "Title 26",
    index: 25,
    id: "imagen26"
  }
];

const styles = StyleSheet.create({

  container: {
    flex: 1,
    backgroundColor: '#f9f6f7', // rose-50
    paddingHorizontal: 20,
    paddingVertical: 40,
    borderTopWidth: 1
  },
  header: {
    alignItems: 'center',
    marginBottom: 40,
  },
  mainIcon: {
    marginBottom: 16,
  },
  underline: {
    height: 2,
    width: 80,
    backgroundColor: '#fda4af',
    marginBottom: 20,
  },
  description: {
    textAlign: 'center',
    color: '#4b5563',
    lineHeight: 22,
    fontSize: 16,
  },
  card: {
    maxWidth: '800px',
    display: 'grid',
    // FORZAMOS 3 columnas siempre, incluso en móvil
    gridTemplateColumns: 'repeat(3, 1fr)',
    // El gap se ajusta proporcionalmente al ancho de pantalla
    gap: 'clamp(4px, 1.5vw, 20px)',
    backgroundColor: '#fff',
    borderRadius: 20,
    padding: 24,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 10 },
    shadowOpacity: 0.1,
    shadowRadius: 15,
    width: '95vw'

  },
  cardHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 24,
  },
  cardTitle: {
    fontSize: 20,
    marginLeft: 12,
    color: '#1f2937',
  },
  grid: {
    gap: 16,
  },
  methodBox: {
    borderWidth: 2,
    borderColor: '#e5e7eb',
    borderRadius: 12,
    padding: 16,
  },
  methodHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 12,
  },
  iconContainer: {
    width: 48,
    height: 48,
    borderRadius: 10,
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 12,
  },
  methodEmoji: {
    fontSize: 24,
  },
  methodName: {
    fontSize: 16,
    fontWeight: '700',
    color: '#111827',
  },
  tapToCopy: {
    fontSize: 12,
    color: '#9ca3af',
  },
  handleContainer: {
    backgroundColor: '#f9fafb',
    borderRadius: 8,
    padding: 10,
  },
  handleText: {
    textAlign: 'center',
    fontFamily: 'Platform' === 'ios' ? 'Courier' : 'monospace',
    color: '#374151',
  },
  footerInfo: {
    marginTop: 24,
    paddingTop: 24,
    borderTopWidth: 1,
    borderTopColor: '#e5e7eb',
    alignItems: 'center',
  },
  footerText: {
    color: '#4b5563',
    fontSize: 13,
  },
  cardTitleCentered: {
    fontSize: 22,
    textAlign: 'center',
    marginBottom: 24,
    color: '#1f2937',
  },
  traditionalGrid: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  storeButton: {
    alignItems: 'center',
    flex: 1,
  },
  storeIcon: {
    width: 60,
    height: 60,
    borderRadius: 30,
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 8,
  },
  storeName: {
    fontSize: 12,
    fontWeight: '600',
    color: '#4b5563',
  },
  storeColor0: { backgroundColor: '#3b82f6' },
  storeColor1: { backgroundColor: '#ef4444' },
  storeColor2: { backgroundColor: '#10b981' },
  lastCard: {
    marginBottom: 80,
  }
});